import React, { ChangeEvent, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, InputLabel, Select, MenuItem, Tooltip, Zoom } from '@material-ui/core';
import { Container, Typography, List, ListItem, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Modal } from '@material-ui/core';
import Button from '@mui/material/Button';
import { Typography as MuiTypography } from '@mui/material';
import { connect, ConnectedProps } from 'react-redux';
import store from './../redux/store';

import { fetchEmpresas } from '../redux/empresas/actions';
import { setUser } from '../redux/user/actions';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import { InputAdornment } from '@material-ui/core';
import { Email, Phone, Business, ImageSearch, ViewHeadline } from '@material-ui/icons';
import { getEmpresas } from '../api';
import { green } from '@material-ui/core/colors';
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import {
  useGridApiRef,
  GridRowsProp,
  GridRowModesModel,
  GridRowModes,
  DataGrid,
  GridColDef,
  GridToolbar,
  GridToolbarContainer,
  GridActionsCellItem,
  GridEventListener,
  GridRowId,
  GridRowModel,
  GridRowEditStopReasons,
  GridValueGetterParams,
  GridToolbarExport,
} from '@mui/x-data-grid';
import { Autocomplete, CircularProgress, Divider, LinearProgress, ListItemButton, ListSubheader, Stack } from '@mui/material';

import dayjs, { Dayjs } from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { DefaultizedPieValueType } from '@mui/x-charts';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';

// Core viewer
import { Viewer, Worker } from '@react-pdf-viewer/core';

// Plugins
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';


import { client, AUTH_USER, getUsers, filterCompany, whoami, UPDATE_USER, REMOVE_COMPANY, CREATE_COMPANY, getCategories, getInvoices, UPDATE_COMPANY, filterTransaction, verificarStatusCliente, recuperarHistoricoDeCobrancas, cancelarAssinatura, filterCredit, filterChatgpt } from '../graphqlClient/graphql'
import { useMutation } from '@apollo/client';
import Notifications from './../components/notifications/Notifications';
import { UploadFile } from '@mui/icons-material';
import { serverConfig } from './../api/apiConfig';
import { number } from 'react-admin';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
    textAlign: 'center',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    //alignItems: 'center',
    height: '100%',
  },
  content: {
    width: '100%!important',
    maxWidth: '100%!important',
    textAlign: 'center',
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between!important',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  deleteButton: {
    marginLeft: theme.spacing(1),
  },
  addButton: {
    margin: theme.spacing(2),
    backgroundColor: green[500],
    color: 'white',
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
}));

const workerUrl = new URL(
  'https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js',
  import.meta.url,
).toString();

type PropsFromRedux = ConnectedProps<typeof connector>;

const InvoicesPage: React.FC<PropsFromRedux> = ({ user, setUser }) => {
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height
    };
  }
  // Create new plugin instance
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const screenWidth: any = getWindowDimensions().width
  const screenHeight: any = getWindowDimensions().height
  const classes = useStyles();
  const navigate = useNavigate();
  const [CreateCompanyMutation, { data }] = useMutation(CREATE_COMPANY);
  const [UpdateCompanyMutation, { data: updateCompanyData }] = useMutation(UPDATE_COMPANY);
  const [RemoveCompanyMutation] = useMutation(REMOVE_COMPANY);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);
  const [selectedCompany, setSelectedCompany] = React.useState('');
  const [selectedCategory, setSelectedCategory] = React.useState<any>({});
  const [addCompanyModalOpen, setAddCompanyModalOpen] = React.useState(false);
  const [newCompany, setNewCompany] = React.useState<any>({});

  const [editData, setEditData] = React.useState<any>({});
  const [invoices, setInvoices] = React.useState<any>([]);
  const [categories, setCategories] = React.useState<any>([]);

  const [editCompanyModalOpen, setEditCompanyModalOpen] = React.useState(false);
  const [isLoadingInvoices, setIsLoadingInvoices] = React.useState(false);
  const [isLoadingInvoicesByFilter, setIsLoadingInvoicesByFilter] = React.useState(false);
  const [passwordOpen, setPasswordOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const permissoesList = ['administrador', 'gerente', 'basico']

  const [rows, setRows] = React.useState(invoices);
  const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
  const [save, setSave] = React.useState(false);
  const [selectedUser, setSelectedUser] = React.useState<any>({ key: 0, value: 'Filtro por operador' });

  const [startDate, setStartDate] = React.useState<any>(null);
  const [endDate, setEndDate] = React.useState<any>(null);
  const [file, setFile] = React.useState<File>();
  const [image, setImage] = React.useState<any>('');
  const [open, setOpen] = React.useState<boolean>(false);
  const [uploadScreen, setUploadScreen] = React.useState<boolean>(false);
  const [openPdf, setOpenPdf] = React.useState<boolean>(false);
  const [imageToOpen, setImageToOpen] = React.useState<any>('');
  const [pdfPath, setPdfPath] = React.useState<any>('');
  const [status, setStatus] = React.useState<any>('');
  const [plan, setPlan] = React.useState<any>('');
  const [totalCredits, setTotalCredits] = React.useState<any>(0);
  const [usedCredits, setUsedCredits] = React.useState<any>(0);
  const [amountInterview, setAmountInterview] = React.useState<any>(0);
  const [amountVisa, setAmountVisa] = React.useState<any>(0);
  const [totalVisaCredits, setTotalVisaCredits] = React.useState<number>(0);
  const [usedVisaCredits, setUsedVisaCredits] = React.useState<number>(0);
  const [remainingVisaCredits, setRemainingVisaCredits] = React.useState<number>(0);
  const [referralsRemaining, setReferralsRemaining] = React.useState(0);
  const [referralsRequested, setReferralsRequested] = React.useState(0);
  const [credits, setCredits] = React.useState(0);
  const [planType, setPlanType] = React.useState<string>('');
  const [stripeId, setStripeId] = React.useState<string>('');
  const [cancelLoading, setCancelLoading] = React.useState(false);
  const [creditExpiration, setCreditExpiration] = React.useState<string>('');
  const [creditType, setCreditType] = React.useState<string>('free');
  const apiRef = useGridApiRef();

  useEffect(() => {
    if (invoices.length) {
      setRows(invoices)
      apiRef.current.setColumnVisibility('id', false);
    }

  }, [invoices]);

  useEffect(() => {
    if (!isLoadingInvoices && !isLoadingInvoicesByFilter && (startDate || endDate)) {
      console.log("change filter use effect ", useEffect)
      changeFilter()
    }

  }, [startDate, endDate,]);


  const checkCredit = async (u: any) => {
    setLoading(true)

    if (!u._id) {
      const notData = {
        type: 'error',
        message: "Undefined User",
        title: 'wescout',
        timeOut: 2500,
        callback: () => { },
        priority: true,
      }
      Notifications(notData)
      setLoading(false)
      return
    }

    const objToSend = {
      "active": true,
      "user": u._id,
    }
    console.log('objToSend', objToSend)

    const result = await filterCredit(objToSend)
    console.log('filterCredit result ==>', result)

    if (!Array.isArray(result) || result.length === 0) {
      console.log('No active credits found')
      setLoading(false)
      return
    }

    // Find the best credit: the one with the latest expiration (current cycle)
    // and aggregate resume feedback usage from all active credits
    let creditActual: any = result[0]
    let totalChatgptUsed = 0

    for (const credit of result) {
      // Pick credit with latest expiration as the "current" one
      if (credit.expiration && (!creditActual.expiration || new Date(credit.expiration) > new Date(creditActual.expiration))) {
        creditActual = credit
      }
      // Aggregate resume feedback usage across all active credits
      totalChatgptUsed += credit.chatgpt?.length || 0
    }

    const total = creditActual.amountPdf || 0
    setTotalCredits(total)
    setUsedCredits(totalChatgptUsed)
    setAmountInterview(creditActual.amountInterview || 0)
    setAmountVisa(creditActual.amountVisa || 0)

    // Referrals: count only from current cycle credit
    const currentCycleRequested = creditActual.recommendations?.length || 0
    setReferralsRequested(currentCycleRequested)
    setReferralsRemaining(creditActual.amount - currentCycleRequested)
    setCredits(creditActual.amount)

    // AI Visa Guide calculations
    const totalVisa = creditActual.amountVisa || 0;
    let visaUsed = creditActual.visa?.length || 0;
    try {
      const uId = u?._id || user?._id;
      if (uId) {
        const allVisaChats: any = await filterChatgpt({ user: uId, type: "visachat" });
        if (Array.isArray(allVisaChats)) {
          const cycleVisaChats = allVisaChats.filter((c: any) => {
            if (!creditActual.createdAt) return true;
            const chatDate = new Date(c.createdAt);
            const startDate = new Date(creditActual.createdAt);
            const endDate = creditActual.expiration ? new Date(creditActual.expiration) : new Date();
            return chatDate >= startDate && chatDate <= endDate;
          });
          visaUsed = Math.max(visaUsed, cycleVisaChats.length);
        }
      }
    } catch (e) {
      console.log('Error calculating visa chat count fallback:', e);
    }
    setTotalVisaCredits(totalVisa);
    setUsedVisaCredits(visaUsed);
    setRemainingVisaCredits(Math.max(0, totalVisa - visaUsed));

    // Store expiration and type for cycle display
    if (creditActual.expiration) {
      setCreditExpiration(creditActual.expiration)
    }
    if (creditActual.type) {
      setCreditType(creditActual.type)
    }

    setLoading(false)
    return;
  }


  const verificarStatusClienteAsync = async (transactionId: any) => {

    const objToSend = {
      id: transactionId
      //empresa:empresa
      //usuario : selectedUser?._id || '',

    }
    console.log('objToSend', objToSend)
    const result = await verificarStatusCliente(objToSend)
    console.log('verificarStatusClienteAsync', result)

    if (result?.status) {
      setStatus(result.status)
      if (result.status === 'erro') {
        Notifications({
          type: 'warning',
          message: `Your previous premium subscription could not be found. Please subscribe to Premium again.`,
          title: 'Subscription required',
          timeOut: 6000,
          priority: true,
          callback: () => { }
        });
        setStatus('free');
        setPlanType('free');
        setPlan('Free');
        return;
      }

      const stripeTransaction = result
      try {
        const messageData = JSON.parse(stripeTransaction.message);
        console.log('messageData', messageData);
      } catch (e) {
        console.error('Error parsing JSON:', e);
        console.log('Raw message:', stripeTransaction.message);
      }
    }
  }
  const recuperarHistoricoDeCobrancasAsync = async (transactionId: any) => {

    const objToSend = {
      id: transactionId
      //empresa:empresa
      //usuario : selectedUser?._id || '',

    }
    console.log('objToSend', objToSend)
    const result = await recuperarHistoricoDeCobrancas(objToSend)
    console.log('recuperarHistoricoDeCobrancasAsync', result)

    if (result?.status) {
      const stripeTransaction = result
      try {
        const messageData = JSON.parse(stripeTransaction.message);
        console.log('recuperarHistoricoDeCobrancasAsync', messageData);
        setInvoices(messageData)
      } catch (e) {
        console.error('Error parsing JSON:', e);
        console.log('Raw message:', stripeTransaction.message);
        // Optionally set invoices to empty or handle the error UI
        setInvoices([]);
      }

    }
  }


  const getInvoicesAsync = async () => {
    const objToSend = {
      user: user._id,
    }
    setIsLoadingInvoicesByFilter(true)
    console.log('objToSend', objToSend)

    const result = await filterTransaction(objToSend)
    console.log('filter result ==>>', result)
    setIsLoadingInvoicesByFilter(false)

    if (Array.isArray(result) && result.length) {
      // Prioritize active subscription if any
      const transactionData = result.find((t: any) => t.stripe && (t.active === true && (t.status === 'active' || t.status === 'trialing'))) ||
        result.find((t: any) => t.stripe && t.active === true) ||
        result.slice().reverse().find((t: any) => t.stripe) ||
        result[result.length - 1];
      setPlan(transactionData.name || (transactionData.planType === 'plus' ? 'Plus' : transactionData.planType === 'basic' ? 'Basic' : 'Free'));
      setPlanType(transactionData.planType || '');
      const id = transactionData.stripe;
      setStripeId(id || '');

      if (id) {
        verificarStatusClienteAsync(id);
        recuperarHistoricoDeCobrancasAsync(id);
      } else {
        setStatus(transactionData.status || (transactionData.active ? 'active' : 'canceled'));
      }
      console.log('transactionData', transactionData);
    } else {
      setPlan(user?.currentPlan ? user.currentPlan.charAt(0).toUpperCase() + user.currentPlan.slice(1) : 'Free');
      setPlanType(user?.currentPlan || 'free');
      setStatus(user?.currentPlan && user.currentPlan !== 'free' ? 'active' : 'free');
    }
  }

  const handleCancelSubscription = async () => {
    setCancelLoading(true);
    try {
      const targetId = stripeId || user?._id;
      if (!targetId) {
        throw new Error('Subscription could not be identified.');
      }

      console.log('Cancelling subscription with targetId:', targetId);
      const result = await cancelarAssinatura({ id: targetId });
      console.log('cancelarAssinatura result', result);

      if (result?.status === 'cancelada') {
        const notData = {
          type: 'success',
          message: 'Your subscription has been successfully canceled! Your account has been reverted to Free.',
          title: 'wescout',
          timeOut: 4000,
          callback: () => { },
          priority: true,
        };
        Notifications(notData);

        // Update local state
        setStatus('canceled');
        setPlanType('free');
        setPlan('Free');

        // Sync Redux
        if (setUser && user) {
          const updatedUser = { ...user, currentPlan: 'free', premium: false };
          setUser(updatedUser);
          checkCredit(updatedUser);
        }

        // Refresh invoices / transactions
        getInvoicesAsync();
      } else {
        const notData = {
          type: 'error',
          message: `Failed to cancel: ${result?.message || 'Unknown error'}`,
          title: 'wescout',
          timeOut: 4000,
          callback: () => { },
          priority: true,
        };
        Notifications(notData);
      }
    } catch (err: any) {
      console.error('Error cancelling subscription:', err);
      Notifications({
        type: 'error',
        message: err.message || 'Error cancelling subscription.',
        title: 'wescout',
        timeOut: 4000,
        callback: () => { },
        priority: true,
      });
    } finally {
      setCancelLoading(false);
      setDeleteConfirmationOpen(false);
    }
  };
  /* useEffect(() => {
    if(isLoadingInvoices){
      setLoading(true)
    }
    if(loading && !isLoadingInvoices){
      //getInvoices();
      setLoading(false)
    }
    console.log('isLoadingInvoices ==> ',isLoadingInvoices)
    
  }, [isLoadingInvoices]); */
  useEffect(() => {

    const start = async () => {
      if (user._id) {
        checkCredit(user)
        setIsLoadingInvoices(true)
        //await getCategoriesAsync();
        //getInvoicesAsync();
        getInvoicesAsync()
      }
    }
    start()

  }, [user]);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
      setImage(URL.createObjectURL(e.target.files[0]))
    }
  };
  const clearImage = () => {
    setImage('')

  };



  const handleDeleteClick = (CompanyId: any) => {
    console.log('CompanyId', CompanyId)

    setSelectedCompany(CompanyId);
    setDeleteConfirmationOpen(true);
  };

  const handleDeleteConfirmation = async () => {
    console.log('selectedCompany', selectedCompany)
    try {

      const id: string = selectedCompany
      console.log('id', id)

      const result = await RemoveCompanyMutation({
        variables: {
          id
        },
        onCompleted: ({ removeCompany }) => {

          console.log('company deleted== > ', removeCompany);
          const notData = {
            type: 'success',
            message: `Company removed Successfully!`,
            title: 'wescout',
            timeOut: 2500,
            callback: () => { },
            priority: true,
          }
          getInvoicesAsync()
          Notifications(notData)

          //navigate('/login')
          //setCompany(updateUser);
        }
      });
    } catch (error: any) {
      const notData = {
        type: 'error',
        message: error.message,
        title: 'wescout',
        timeOut: 2500,
        callback: () => { },
        priority: true,
      }
      Notifications(notData)
      console.log("Erro ao deletar company", error)

    }

    setDeleteConfirmationOpen(false);
  };

  const clearNewCompany = () => {
    setNewCompany({})

  }

  const handleAddCompany = async () => {
    const dataToSend = { ...newCompany, createdBy: user._id }
    console.log('dataToSend', dataToSend)
    if (file) {
      console.log(file)
      dataToSend.image = file;
      //dataToSend.contador = (contador+1);
    }
    // dataToSend.id = dataToSend._id
    delete dataToSend.__typename
    console.log('dataToSend', dataToSend)
    if (typeof dataToSend.image == 'string') delete dataToSend.image
    try {

      const createCompanyInput = dataToSend
      console.log('createCompanyInput', dataToSend)

      const result = await CreateCompanyMutation({
        variables: {
          createCompanyInput
        },
        onCompleted: ({ createCompany }) => {

          console.log('company created== > ', createCompany);
          const notData = {
            type: 'success',
            message: `Company ${createCompany?.name} Created Successfully!`,
            title: 'wescout',
            timeOut: 2500,
            callback: () => { },
            priority: true,
          }
          getInvoicesAsync()
          Notifications(notData)

          //navigate('/login')
          //setCompany(updateUser);
        }
      });
    } catch (error: any) {
      const notData = {
        type: 'error',
        message: error.message,
        title: 'wescout',
        timeOut: 2500,
        callback: () => { },
        priority: true,
      }
      Notifications(notData)
      console.log("Erro ao criar usuário", error)

    }
    setAddCompanyModalOpen(false);
    clearNewCompany()
  };


  const validateEmail = (email: any) => {
    return true
    // Implemente a lógica de validação do e-mail aqui
  };

  const validateCNPJ = (cnpj: any) => {
    // Remove caracteres não numéricos
    cnpj = cnpj.replace(/[^\d]+/g, '');

    // Verifica se possui 14 dígitos
    if (cnpj.length !== 14) {
      return false;
    }

    // Verifica se todos os dígitos são iguais (ex: 00000000000000)
    if (/^(\d)\1+$/.test(cnpj)) {
      return false;
    }

    // Validação do primeiro dígito verificador
    let sum = 0;
    let factor = 5;
    for (let i = 0; i < 12; i++) {
      sum += parseInt(cnpj[i]) * factor;
      factor = factor === 2 ? 9 : factor - 1;
    }

    let digit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (parseInt(cnpj[12]) !== digit) {
      return false;
    }

    // Validação do segundo dígito verificador
    sum = 0;
    factor = 6;
    for (let i = 0; i < 13; i++) {
      sum += parseInt(cnpj[i]) * factor;
      factor = factor === 2 ? 9 : factor - 1;
    }

    digit = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (parseInt(cnpj[13]) !== digit) {
      return false;
    }

    return true;
  };


  const maskCNPJ = (cnpj: any) => {
    // Remove caracteres não numéricos
    cnpj = cnpj.replace(/[^\d]+/g, '');

    // Aplica a máscara
    cnpj = cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');

    return cnpj;
  };

  const validatePhone = (phone: any) => {
    // Remove caracteres não numéricos
    phone = phone.replace(/[^\d]+/g, '');

    // Verifica se possui 11 dígitos (considerando o DDD)
    if (phone.length !== 11) {
      return false;
    }

    // Verifica se todos os dígitos são iguais (ex: 00000000000)
    if (/^(\d)\1+$/.test(phone)) {
      return false;
    }

    return true;
  };

  const maskPhone = (phone: any) => {
    // Remove caracteres não numéricos
    phone = phone.replace(/[^\d]+/g, '');

    // Aplica a máscara
    phone = phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');

    return phone;
  };

  const handleEditCompany = (data: any) => {
    console.log('data selecionada ==>> ', data)
    setEditData(data);
    setEditCompanyModalOpen(true);
  };

  const handleUpdateCompany = async (data?: any) => {

    let dataToSend = { ...editData }
    if (!dataToSend._id) dataToSend = { ...data }
    console.log('dataToSend', dataToSend)

    if (file) {
      console.log(file)
      dataToSend.image = file;
      //dataToSend.contador = (contador+1);
    }
    // dataToSend.id = dataToSend._id
    if (dataToSend.__typename)
      delete dataToSend.__typename
    if (dataToSend.createdAt)
      delete dataToSend.createdAt
    if (dataToSend.isNew != "undefined") delete dataToSend.isNew;

    if (dataToSend.createdBy)
      delete dataToSend.createdBy
    if (dataToSend.category && typeof dataToSend.category === "object")
      delete dataToSend.category

    //console.log('dataToSend',dataToSend)
    if (typeof dataToSend.image == 'string') delete dataToSend.image
    try {

      const updateCompanyInput = dataToSend
      console.log('updateCompanyInput', dataToSend)

      const result = await UpdateCompanyMutation({
        variables: {
          updateCompanyInput
        },
        onCompleted: ({ updateCompany }) => {

          console.log('company updated== > ', updateCompany);
          const notData = {
            type: 'success',
            message: `Company ${updateCompany?.name} Updated Successfully!`,
            title: 'wescout',
            timeOut: 2500,
            callback: () => { },
            priority: true,
          }
          setEditData({});
          setEditCompanyModalOpen(false);
          getInvoicesAsync()
          Notifications(notData)

          //navigate('/login')
          //setCompany(updateUser);
        }
      });
    } catch (error: any) {
      const notData = {
        type: 'error',
        message: error.message,
        title: 'wescout',
        timeOut: 2500,
        callback: () => { },
        priority: true,
      }
      Notifications(notData)
      console.log("Erro ao criar usuário", error)

    }

    //clearNewCompany()
    //updateCompany(dataToSend)
    setEditData({});
    setEditCompanyModalOpen(false);
    // Lógica para atualizar a Company com os dados do modal
  };

  const validatePassword = (password: string | any[]) => {
    return password.length >= 6;
  };

  const validateConfirmPassword = (password: any, confirmPassword: any) => {
    return password === confirmPassword;
  };



  //init DataGrid dependencies

  const clearData = (d: any) => {
    const dateTransform = (moment(d).format('DD-MM-YYYY h:m'));
    return dateTransform
  }

  const handleRowEditStop: GridEventListener<'rowEditStop'> = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleEditClick = (id: GridRowId) => () => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
  };

  interface EditToolbarProps {
    setRows: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void;
    setRowModesModel: (
      newModel: (oldModel: GridRowModesModel) => GridRowModesModel,
    ) => void;
  }

  const _ = (id: GridRowId) => () => {
    setRows(rows.filter((row: any) => row._id !== id));
  };

  const handleCancelClick = (id: GridRowId) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });

    const editedRow = rows.find((row: any) => row._id === id);
    if (editedRow!.isNew) {
      setRows(rows.filter((row: any) => row._id !== id));
    }
  };

  const processRowUpdate: any = (newRow: GridRowModel) => {
    const updatedRow = { ...newRow, isNew: false };
    console.log('newRow', newRow)
    if (newRow.isNew) {
      delete newRow.isNew
    }
    setEditData(newRow)
    setRows(rows.map((row: any) => (row._id === newRow._id ? updatedRow : row)));
    handleUpdateCompany(newRow)
    return updatedRow;
  };

  const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handleClickImage = () => {
    setOpen((previousOpen) => !previousOpen);
  }

  const ImageComponent = (obj: any) => {
    console.log(obj)
    //setEditReferenciaData(obj.obj.row)
    if (obj.obj.image) {
      const imagePath = obj.obj.image.indexOf('//') > 0 ? obj.obj.image : serverConfig.dev.url + 'images/' + obj.obj.image;
      return (
        <div style={{ alignSelf: 'center', margin: "0 auto" }} onClick={() => {
          //console.log(imagePath)
          setImageToOpen(imagePath)
          console.log(imageToOpen)
          handleClickImage()
        }}>
          <img style={{ objectFit: 'cover' }} height={53} src={imagePath} />
        </div>

      )
    } else {
      return (
        <IconButton onClick={
          () => {
            setEditData(obj.obj)
            setUploadScreen(true)

            //handleEditReferencia(obj.obj.row)
          }
        }>
          <ImageSearch />
        </IconButton>
      )
    }

  }


  const handleSaveClick = (id: GridRowId) => () => {
    const el = rows.filter((item: any) => item._id == id)
    console.log('handleSaveClick', id)
    console.log('handleSaveClick el', el)
    setSave(true)
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };


  const formatDate = (unix_timestamp: any) => {


    // Create a new JavaScript Date object based on the timestamp
    // multiplied by 1000 so that the argument is in milliseconds, not seconds
    var date = new Date(unix_timestamp * 1000);

    // Hours part from the timestamp
    var day = date.getDate();

    // Minutes part from the timestamp
    var month = date.getMonth() + 1;

    // Seconds part from the timestamp
    var year = date.getFullYear();

    // Will display time in 10:30:23 format
    const formattedTime = month + '/' + day + '/' + year;

    console.log(formattedTime);
    return formattedTime
  }

  const viewInvoice = (path: any) => {

    console.log('path', path)
    setPdfPath(path)
    //setOpenPdf(true)
    window.open(path, '_blank');



  }




  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 90 },

    {
      field: 'period_start',
      headerName: 'Date',
      type: 'Date',
      width: 140,
      editable: false,
      valueGetter: (params: GridValueGetterParams) => formatDate(params.row.period_start)
    },
    {
      field: 'customer_email',
      headerName: 'E-mail',
      width: 150,
      editable: false,
      //valueGetter : (params: GridValueGetterParams)=> getCategoriaNome(params.row.categoria)
    },
    {
      field: 'name',
      headerName: 'Plan',
      width: 150,
      editable: false,
      //valueGetter : (params: GridValueGetterParams)=> getCategoriaNome(params.row.categoria)
    },

    /* {
      field: 'email',
      headerName: 'E-mail',
      width: 150,
      editable: true,
      //valueGetter : (params: GridValueGetterParams)=> getCategoriaNome(params.row.categoria)
    }, */
    {
      field: "period_end",
      headerName: 'Renewal cycle',
      width: 160,
      //valueSetter:  (value: any) => {console.log('value setter',value);return value.name},
      getOptionValue: (value: any) => value._id,
      getOptionLabel: (value: any) => {
        //console.log('value label',value);
        return value.name
      },
      valueGetter: (params: GridValueGetterParams) => formatDate(params.row.period_end)
    },
    {
      field: "amount_paid",
      headerName: 'Value',
      width: 160,
      //valueSetter:  (value: any) => {console.log('value setter',value);return value.name},
      getOptionValue: (value: any) => value._id,
      getOptionLabel: (value: any) => {
        //console.log('value label',value);
        return value.name
      },
      valueGetter: (params: GridValueGetterParams) => (Number(params.row.amount_paid) / 100).toLocaleString('pt-br', { minimumFractionDigits: 2 })
    },
    {
      field: "currency",
      headerName: 'Currency',
      width: 80,

    },
    /* {
      field: 'createdBy',
      headerName: 'Created by',
      width: 120,
      editable: false,
      valueGetter : (params: GridValueGetterParams)=> params.row.createdBy.name || ''
    }, */




    /* {
      field: 'identificacao',
      headerName: 'código',
      description: 'código do item',
      sortable: false,
      width: 140,
      valueGetter: (params: GridValueGetterParams) =>
        `${params.row.identificacao[0].codigo || ''}  `,
    }, 
   */
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      width: 150,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        const cat = invoices.filter((item: any) => item._id == id)[0]
        const item = rows.filter((item: any) => item.id == id)[0]
        return [<GridActionsCellItem
          icon={
            <Tooltip TransitionComponent={Zoom} title="Download invoice" arrow>
              <IconButton size='small' className='iconDetail' color="primary" aria-label="Editar" >
                <ViewHeadline />
              </IconButton>
            </Tooltip>
          }
          label="Invoice"
          onClick={() => {
            viewInvoice(item.hosted_invoice_url)
            //viewInvoice(item.invoice_pdf)
          }}
          color="inherit"
        />,];





      },
    },


  ];

  const hiddenFields = ['_id', 'id', 'ID'];

  const getTogglableColumns = (columns: GridColDef[]) => {
    console.log('getTogglableColumns', columns)
    return columns
      .filter((column) => !hiddenFields.includes(column.field))
      .map((column) => column.field);
  };

  const changeFilter = async () => {

    const objToSend = {
      user: user._id,
      endDate,
      //empresa:empresa
      //usuario : selectedUser?._id || '',

    }
    setIsLoadingInvoicesByFilter(true)
    console.log('objToSend', objToSend)

    const result = await filterTransaction(objToSend)
    console.log('filter result ==>>', result)
    //getProductsByFilter(objToSend)
    //getInvoicesByFilter(objToSend)
    setIsLoadingInvoicesByFilter(false)
    //setInvoices(result)
    //setSelectedCategory({})
  }

  const normalizedPlanType = (planType || user?.currentPlan || '').toLowerCase();
  const isPaidPlan = normalizedPlanType !== '' && normalizedPlanType !== 'free';
  const isSubActive = isPaidPlan && status !== 'canceled' && status !== 'free' && (status === 'active' || status === 'trialing' || (!status && user?.premium));

  return (
    <Container className={classes.container}>
      <Modal onClick={(evt) => {
        setImageToOpen('')
        handleClickImage()
      }} open={open} style={{
        width: '100%', textAlign: 'center', display: 'flex',
        alignItems: 'center', justifyContent: 'space-between', backgroundColor: 'white'
      }}>
        <Box>
          <Typography>
            clique para fechar
          </Typography>
          <Typography>
            {/* {editProdutoData.referencia?.nome} */}
          </Typography>
          <img width={500} style={{ border: '2px solid white', maxHeight: '80vh' }}
            src={`${imageToOpen}?w=248&fit=crop&auto=format`}
            srcSet={`${imageToOpen}?w=248&fit=crop&auto=format&dpr=2 2x`}
            alt={''}
            loading="lazy"

          />
        </Box>


      </Modal>
      <div className='root'>
        <div className={classes.content}>

          {/* ===== PLAN & CREDITS SECTION ===== */}
          <Box sx={{
            maxWidth: 900,
            margin: '0 auto 32px',
            textAlign: 'left',
          }}>
            {/* Plan Header */}
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mb: 3,
              flexWrap: 'wrap',
              gap: 2,
            }}>
              <Box>
                <MuiTypography variant="h4" sx={{ fontWeight: 700, color: '#fff' }}>
                  {plan || (planType ? planType.charAt(0).toUpperCase() + planType.slice(1) : 'Free')} Plan
                </MuiTypography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                  <Box sx={{
                    display: 'inline-block',
                    px: 1.5,
                    py: 0.3,
                    borderRadius: '12px',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    backgroundColor: status === 'active' ? 'rgba(57, 255, 20, 0.15)'
                      : status === 'canceled' ? 'rgba(255, 0, 0, 0.15)'
                        : 'rgba(255, 255, 255, 0.1)',
                    color: status === 'active' ? '#39FF14'
                      : status === 'canceled' ? '#ff4444'
                        : '#aaa',
                    border: `1px solid ${status === 'active' ? 'rgba(57, 255, 20, 0.3)'
                      : status === 'canceled' ? 'rgba(255, 0, 0, 0.3)'
                        : 'rgba(255, 255, 255, 0.15)'}`,
                  }}>
                    {status || 'free'}
                  </Box>
                  {creditExpiration && (
                    <MuiTypography variant="body2" sx={{ color: '#888', fontSize: '0.8rem' }}>
                      Renews {new Date(creditExpiration).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                    </MuiTypography>
                  )}
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                {isPaidPlan && isSubActive && (
                  <Button
                    variant="outlined"
                    disabled={cancelLoading}
                    onClick={() => setDeleteConfirmationOpen(true)}
                    sx={{
                      color: '#ff4444',
                      borderColor: 'rgba(255, 68, 68, 0.5)',
                      borderRadius: '8px',
                      textTransform: 'none',
                      fontWeight: 600,
                      px: 2.5,
                      py: 0.8,
                      backgroundColor: 'rgba(255, 68, 68, 0.05)',
                      '&:hover': {
                        borderColor: '#ff4444',
                        backgroundColor: 'rgba(255, 68, 68, 0.15)',
                      }
                    }}
                  >
                    {cancelLoading ? 'Cancelling...' : 'Cancel Subscription'}
                  </Button>
                )}
                {(!isPaidPlan || !isSubActive) && (
                  <Button
                    variant="contained"
                    onClick={() => navigate('/getpremium')}
                    sx={{
                      background: 'linear-gradient(135deg, #8A2BE2, #00FFFF)',
                      color: '#fff',
                      fontWeight: 600,
                      borderRadius: '8px',
                      textTransform: 'none',
                      px: 3,
                      py: 0.8,
                      '&:hover': { background: 'linear-gradient(135deg, #7B27CC, #00E5E5)' }
                    }}
                  >
                    Upgrade Plan
                  </Button>
                )}
              </Box>
            </Box>

            {/* Credits Grid */}
            <MuiTypography variant="h6" sx={{ fontWeight: 600, color: '#fff', mb: 2 }}>
              Monthly Credits
            </MuiTypography>
            <Box sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)', md: 'repeat(3, 1fr)' },
              gap: 2,
              mb: 4,
            }}>
              {/* Referrals Card */}
              <Box sx={{
                background: 'rgba(138, 43, 226, 0.08)',
                border: '1px solid rgba(138, 43, 226, 0.25)',
                borderRadius: '12px',
                p: 2.5,
                transition: 'all 0.2s',
                '&:hover': { border: '1px solid rgba(138, 43, 226, 0.5)', transform: 'translateY(-2px)' },
              }}>
                <MuiTypography variant="body2" sx={{ color: '#aaa', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px', mb: 1 }}>
                  Referrals
                </MuiTypography>
                <MuiTypography variant="h4" sx={{ color: '#8A2BE2', fontWeight: 700 }}>
                  {referralsRemaining}
                  <MuiTypography component="span" sx={{ color: '#666', fontSize: '1rem', fontWeight: 400 }}> / {credits}</MuiTypography>
                </MuiTypography>
                <Box sx={{ mt: 1.5, height: 4, borderRadius: 2, backgroundColor: 'rgba(138, 43, 226, 0.15)' }}>
                  <Box sx={{ height: '100%', borderRadius: 2, backgroundColor: '#8A2BE2', width: credits > 0 ? `${(referralsRemaining / credits) * 100}%` : '0%', transition: 'width 0.5s ease' }} />
                </Box>
                <MuiTypography variant="body2" sx={{ color: '#666', fontSize: '0.7rem', mt: 1 }}>
                  {referralsRequested} used
                </MuiTypography>
              </Box>

              {/* Resume Feedback Card */}
              <Box sx={{
                background: 'rgba(0, 255, 255, 0.06)',
                border: '1px solid rgba(0, 255, 255, 0.2)',
                borderRadius: '12px',
                p: 2.5,
                transition: 'all 0.2s',
                '&:hover': { border: '1px solid rgba(0, 255, 255, 0.45)', transform: 'translateY(-2px)' },
              }}>
                <MuiTypography variant="body2" sx={{ color: '#aaa', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px', mb: 1 }}>
                  Resume Feedback
                </MuiTypography>
                <MuiTypography variant="h4" sx={{ color: '#00FFFF', fontWeight: 700 }}>
                  {totalCredits - usedCredits}
                  <MuiTypography component="span" sx={{ color: '#666', fontSize: '1rem', fontWeight: 400 }}> / {totalCredits}</MuiTypography>
                </MuiTypography>
                <Box sx={{ mt: 1.5, height: 4, borderRadius: 2, backgroundColor: 'rgba(0, 255, 255, 0.12)' }}>
                  <Box sx={{ height: '100%', borderRadius: 2, backgroundColor: '#00FFFF', width: totalCredits > 0 ? `${((totalCredits - usedCredits) / totalCredits) * 100}%` : '0%', transition: 'width 0.5s ease' }} />
                </Box>
                <MuiTypography variant="body2" sx={{ color: '#666', fontSize: '0.7rem', mt: 1 }}>
                  {usedCredits} used
                </MuiTypography>
              </Box>

              {/* Interview Card */}
              {/* <Box sx={{
                background: 'rgba(57, 255, 20, 0.06)',
                border: '1px solid rgba(57, 255, 20, 0.2)',
                borderRadius: '12px',
                p: 2.5,
                transition: 'all 0.2s',
                '&:hover': { border: '1px solid rgba(57, 255, 20, 0.45)', transform: 'translateY(-2px)' },
              }}>
                <MuiTypography variant="body2" sx={{ color: '#aaa', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px', mb: 1 }}>
                  Interviews
                </MuiTypography>
                <MuiTypography variant="h4" sx={{ color: '#39FF14', fontWeight: 700 }}>
                  {amountInterview}
                </MuiTypography>
                <MuiTypography variant="body2" sx={{ color: '#666', fontSize: '0.7rem', mt: 2.5 }}>
                  simulations available
                </MuiTypography>
              </Box> */}

              {/* Visa Guide Card */}
              <Box sx={{
                background: 'rgba(255, 0, 255, 0.06)',
                border: '1px solid rgba(255, 0, 255, 0.2)',
                borderRadius: '12px',
                p: 2.5,
                transition: 'all 0.2s',
                '&:hover': { border: '1px solid rgba(255, 0, 255, 0.45)', transform: 'translateY(-2px)' },
              }}>
                <MuiTypography variant="body2" sx={{ color: '#aaa', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px', mb: 1 }}>
                  AI Visa Guide
                </MuiTypography>
                <MuiTypography variant="h4" sx={{ color: '#FF00FF', fontWeight: 700 }}>
                  {remainingVisaCredits}
                  <MuiTypography component="span" sx={{ color: '#666', fontSize: '1rem', fontWeight: 400 }}> / {totalVisaCredits}</MuiTypography>
                </MuiTypography>
                <Box sx={{ mt: 1.5, height: 4, borderRadius: 2, backgroundColor: 'rgba(255, 0, 255, 0.12)' }}>
                  <Box sx={{ height: '100%', borderRadius: 2, backgroundColor: '#FF00FF', width: totalVisaCredits > 0 ? `${(remainingVisaCredits / totalVisaCredits) * 100}%` : '0%', transition: 'width 0.5s ease' }} />
                </Box>
                <MuiTypography variant="body2" sx={{ color: '#666', fontSize: '0.7rem', mt: 1 }}>
                  {usedVisaCredits} used
                </MuiTypography>
              </Box>
            </Box>
          </Box>

          {/* ===== INVOICES SECTION ===== */}
          <Box sx={{ maxWidth: 900, margin: '0 auto' }}>
            <MuiTypography variant="h5" sx={{ fontWeight: 600, color: '#fff', mb: 2, textAlign: 'left' }}>
              Invoices
            </MuiTypography>
          </Box>
          {loading ? (
            <Box sx={{ width: '100%' }}>
              <LinearProgress />
            </Box>
          ) : null}
          {/* <Button className={classes.addButton} variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => setAddCompanyModalOpen(true)}>
            add 
          </Button> */}



          {invoices.length ? (
            <Box sx={{ width: '100%', alignItems: "center" }} style={{ display: 'flex', marginTop: 20, flexDirection: 'column', justifyContent: 'space-around', alignSelf: 'center', paddingBottom: 10, borderColor: 'green', borderWidth: 2 }}>

              <DataGrid
                apiRef={apiRef}
                loading={isLoadingInvoicesByFilter}
                getRowId={(row: { id: any; }) => row.id}
                //checkboxSelection
                disableRowSelectionOnClick

                onClipboardCopy={(copiedString) => console.log(copiedString)}
                unstable_ignoreValueFormatterDuringExport
                autoHeight={true}
                rows={rows}
                columns={columns}
                initialState={{
                  sorting: {
                    sortModel: [{ field: 'createdAt', sort: 'asc' }],
                  },

                  pagination: {
                    paginationModel: {
                      pageSize: 15,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                //checkboxSelection

                //editMode="row"
                rowModesModel={rowModesModel}
                onRowModesModelChange={handleRowModesModelChange}
                onRowEditStop={handleRowEditStop}
                processRowUpdate={processRowUpdate}
                // slots={{
                //   toolbar: EditToolbar,
                // }}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    setRows, setRowModesModel, csvOptions: {
                      fileName: 'invoicesDataBase_',
                      delimiter: ';',
                      utf8WithBom: true,
                    },
                    columns: {
                      columnVisibilityModel: { ID: false, },
                    },
                    columnsPanel: {
                      getTogglableColumns,
                    },
                    printOptions: { hideToolbar: true, disableToolbarButton: false }
                  },
                }}



              //toolbar: { printOptions: { getRowsToExport: getSelectedRowsToExport } },


              />

            </Box>
          ) : (<div style={{ margin: 15 }}>
            No records found
          </div>)}


          <Stack width={'100%'} margin={'40px auto 20px'} alignItems="center">
            {isPaidPlan && isSubActive && (
              <Button
                variant="outlined"
                disabled={cancelLoading}
                onClick={() => setDeleteConfirmationOpen(true)}
                sx={{
                  color: '#ff4444',
                  borderColor: 'rgba(255, 68, 68, 0.5)',
                  borderRadius: '8px',
                  px: 3,
                  py: 1,
                  textTransform: 'none',
                  fontWeight: 600,
                  backgroundColor: 'rgba(255, 68, 68, 0.05)',
                  '&:hover': {
                    borderColor: '#ff4444',
                    backgroundColor: 'rgba(255, 68, 68, 0.15)',
                  }
                }}
              >
                {cancelLoading ? 'Cancelling...' : 'Cancel your subscription'}
              </Button>
            )}
          </Stack>
          <Button className='backbutton' onClick={() => navigate(-1)}>Go Back</Button>
        </div>
      </div>


      <Modal className={'modalContent'} open={openPdf} onClose={() => setOpenPdf(false)}   >
        <div style={{ margin: 0, backgroundColor: 'white', width: screenWidth }} className={'modalContent'}>

          <Button className='backbutton' onClick={() => setOpenPdf(false)}>Close</Button>




          <Worker workerUrl={workerUrl}>
            <Viewer
              fileUrl={pdfPath}
              plugins={[
                // Register plugins
                defaultLayoutPluginInstance,
              ]}

            />
          </Worker>


        </div>
      </Modal>

      <Dialog
        open={deleteConfirmationOpen}
        onClose={() => !cancelLoading && setDeleteConfirmationOpen(false)}
        PaperProps={{
          style: {
            backgroundColor: '#111115',
            color: '#ffffff',
            borderRadius: '16px',
            border: '1px solid rgba(255, 68, 68, 0.3)',
            boxShadow: '0 8px 32px 0 rgba(255, 68, 68, 0.2)',
            padding: '8px',
            maxWidth: '480px',
            width: '95%'
          }
        }}
      >
        <DialogTitle style={{ color: '#ff4444', fontWeight: 700, fontSize: '1.25rem' }}>
          Cancel Subscription
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" style={{ color: '#ffffff', lineHeight: 1.6, marginBottom: '12px' }}>
            Are you sure you want to cancel your <strong>{plan || (planType ? planType.charAt(0).toUpperCase() + planType.slice(1) : 'current')}</strong> subscription?
          </Typography>
          <Box sx={{
            backgroundColor: 'rgba(255, 68, 68, 0.08)',
            border: '1px solid rgba(255, 68, 68, 0.25)',
            borderRadius: '8px',
            p: 1.5,
            mb: 1
          }}>
            <Typography variant="body2" style={{ color: '#ff9999', lineHeight: 1.5, fontSize: '0.85rem' }}>
              ⚠️ Your subscription will be cancelled on Stripe immediately. Your account will revert to the <strong>Free Plan</strong> and paid cycle benefits will no longer renew.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px', gap: '12px' }}>
          <Button
            onClick={() => setDeleteConfirmationOpen(false)}
            disabled={cancelLoading}
            style={{ color: '#aaa', textTransform: 'none', fontWeight: 600 }}
          >
            No, keep my plan
          </Button>
          <Button
            variant="contained"
            disabled={cancelLoading}
            onClick={handleCancelSubscription}
            style={{
              backgroundColor: '#ff4444',
              color: '#ffffff',
              textTransform: 'none',
              fontWeight: 700,
              borderRadius: '8px',
              padding: '8px 20px',
              minWidth: '130px'
            }}
          >
            {cancelLoading ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CircularProgress size={18} style={{ color: '#fff' }} />
                <span>Cancelling...</span>
              </Box>
            ) : (
              'Yes, cancel'
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={addCompanyModalOpen} onClose={() => setAddCompanyModalOpen(false)}>
        <DialogTitle>Add new company</DialogTitle>
        <DialogContent className={classes.modalContent}>

          <div className="file-upload-img">
            {image ? <img src={image} alt="upload" /> : <UploadFile />}
            {/* <Avatar sx={{ width: 108, height: 108 }} style={{margin:'0 auto'}} alt={usuario.name} src={image||usuario.avatar} /> */}

            {file ? <div style={{ color: 'white' }}>file to upload: <span className='subtitle'>{file.name}</span> . </div> : null}
            {/* <h3> {file?.name || "Choose a pdf file"}</h3> */}
            <p>Maximum length 10mb</p>
            {/* <input type="file" onChange={handleFileChange} /> */}
            {
              !file?.name || !image ? <label htmlFor="contained-button-file">
                <input
                  accept="application/image"
                  style={{ display: 'none' }}
                  id="contained-button-file"
                  type="file"
                  onChange={handleFileChange}
                />
                <Button variant="contained" component="span">
                  Choose a image file
                </Button>
              </label> : <Button onClick={() => clearImage()} variant="contained" component="span">
                clear
              </Button>
            }

          </div>



          <TextField
            label="Company name"
            value={newCompany.name}
            onChange={(e) => setNewCompany({ ...newCompany, name: e.target.value })}
          />
          <TextField
            label="Company description"
            value={newCompany.description}
            onChange={(e) => setNewCompany({ ...newCompany, description: e.target.value })}
          />



          {/* <FormControl fullWidth>
              <InputLabel htmlFor="empresa-select">Selecione a Empresa</InputLabel>
              <Select
                value={newCompanyEmpresa}
                onChange={(e:any) => setNewCompanyEmpresa( e.target.value )}
                inputProps={{
                  name: 'empresa',
                  id: 'empresa-select',
                }}
              >
                {empresas.map((empresa: { _id: any; nome: any; }) => (
                  <MenuItem key={empresa._id} value={empresa._id}>
                    {empresa.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel htmlFor="permissao-select">Selecione o tipo de usuário</InputLabel>
              <Select
                value={newCompanyPermissoes}
                onChange={(e:any) => setNewCompanyPermissoes( e.target.value )}
                inputProps={{
                  name: 'permissao',
                  id: 'permissao-select',
                }}
              >
                {permissoesList.map((permissao: any) => (
                  <MenuItem key={permissao} value={permissao}>
                    {permissao}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}


        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddCompanyModalOpen(false)}>Cancelar</Button>
          <Button onClick={handleAddCompany} color="primary">
            Create
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog open={uploadScreen} onClose={() => setUploadScreen(false)}>
        <DialogTitle>Edit company</DialogTitle>
        <DialogContent className={classes.modalContent}>

          <div className="file-upload-img">
            {image ? <img src={image} alt="upload" /> : <UploadFile />}
            {/* <Avatar sx={{ width: 108, height: 108 }} style={{margin:'0 auto'}} alt={usuario.name} src={image||usuario.avatar} /> */}

            {file ? <div style={{ color: 'white' }}>file to upload: <span className='subtitle'>{file.name}</span> . </div> : null}
            {/* <h3> {file?.name || "Choose a pdf file"}</h3> */}
            <p>Maximum length 10mb</p>
            {/* <input type="file" onChange={handleFileChange} /> */}
            {
              !file?.name || !image ? <label htmlFor="contained-button-file">
                <input
                  accept="application/image"
                  style={{ display: 'none' }}
                  id="contained-button-file"
                  type="file"
                  onChange={handleFileChange}
                />
                <Button variant="contained" component="span">
                  Choose a image file
                </Button>
              </label> : <Button onClick={() => clearImage()} variant="contained" component="span">
                clear
              </Button>
            }

          </div>



          <TextField
            label="Company name"
            value={editData.name}
            onChange={(e) => setEditData({ ...editData, name: e.target.value })}
          />
          <TextField
            label="Company description"
            value={newCompany.description}
            onChange={(e) => setEditData({ ...editData, description: e.target.value })}
          />



        </DialogContent>
        <DialogActions>
          <Button onClick={() => setUploadScreen(false)}>Cancelar</Button>
          <Button onClick={handleUpdateCompany} color="primary">
            Update
          </Button>
        </DialogActions>
      </Dialog>
      {editCompanyModalOpen && editData.name ?
        <Dialog maxWidth="lg" open={editCompanyModalOpen} onClose={() => setEditCompanyModalOpen(false)}>
          <DialogTitle>Edit company information</DialogTitle>
          <DialogContent className={classes.modalContent}>
            <TextField
              label="Nome do usuário"
              value={editData.name}
              onChange={(e) => setEditData({ ...editData, name: e.target.value })}
            />
            <TextField
              label="E-mail"
              value={editData.email}
              onChange={(e) => setEditData({ ...editData, email: e.target.value })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email />
                  </InputAdornment>
                ),
              }}
              error={!validateEmail(editData.email)}
              helperText={!validateEmail(editData.email) && 'E-mail inválido'}
            />



            {/* <FormControl fullWidth>
              <InputLabel htmlFor="permissao-select">Selecione o tipo de usuário</InputLabel>
              <Select
                value={newCompanyPermissoes}
                onChange={(e:any) => setNewCompanyPermissoes( e.target.value )}
                inputProps={{
                  name: 'permissao',
                  id: 'permissao-select',
                }}
              >
                {permissoesList.map((permissao: any) => (
                  <MenuItem key={permissao} value={permissao}>
                    {permissao}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}



            {/* <TextField
              label="Empresa"
              value={editData.empresa}
              onChange={(e) => setNewCompanyEmpresa(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Business />
                  </InputAdornment>
                ),
              }}
              error={editData.empresa == ""}

              helperText={
                editData.empresa=="" &&
                'Empresa inválida'
              }
            /> */}



          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditCompanyModalOpen(false)}>Cancelar</Button>
            <Button onClick={handleUpdateCompany} color="primary">
              Atualizar
            </Button>
          </DialogActions>
        </Dialog> : null}


      {/* <Modal open={editCompanyModalOpen} onClose={() => setEditCompanyModalOpen(false)}>
  <div>
    <input
      type="text"
      value={editData.name}
      onChange={(e) => setEditData({ ...editData, nome: e.target.value })}
    />
    <input
      type="text"
      value={editData.email}
      onChange={(e) => setEditData({ ...editData, email: e.target.value })}
    />
    <input
      type="text"
      value={editData.telefone}
      onChange={(e) => setEditData({ ...editData, telefone: e.target.value })}
    />
    <input
      type="text"
      value={editData.cnpj}
      onChange={(e) => setEditData({ ...editData, cnpj: e.target.value })}
    />
    <button onClick={handleUpdateCompany}>Atualizar</button>
  </div>
</Modal> */}
    </Container>
  );
};

const mapStateToProps = (state: any) => ({

  user: state.user.user



});

const mapDispatchToProps = {
  setUser
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(InvoicesPage);
